import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_notifications-user_account-click';
/**
 * Records click on user account icon on top nav
 */
export function trackRetailerNotificationsUserAccountClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
